import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteTopicsFulfilledAction } from '../../domains/checkedTopicsFromDiscoveryTopics/deleteTopicsActions.types';
import type { RemoveTopicFulfilledAction } from '../../domains/topics/removeTopicActions.types';
import type { TopicsSearchRemoveAction } from '../../domains/topicsSearch/actions.types';
import type { TypeaheadAction } from '../../domains/typeahead/actions.types';
import type { Topic } from '../types';

import type { TopicsSearches } from './types';

export type TopicsSearchesAction =
  | TypeaheadAction
  | TopicsSearchRemoveAction
  | DeleteTopicsFulfilledAction
  | RemoveTopicFulfilledAction;

const initialState: TopicsSearches = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const removeFromTopicsSearch = (state: TopicsSearches, topicIds: Topic['id'][]) => {
  const currentSearchTopics = state.fulfilled?.topicIds ?? [];
  const searchText = state.fulfilled?.searchText ?? '';

  if (currentSearchTopics.length === 0) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      searchText,
      topicIds: currentSearchTopics.filter((id: Topic['id']) => !topicIds.includes(id)),
    },
  };
};

const reducer: Reducer<TopicsSearches, TopicsSearchesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TYPEAHEAD.LOAD_PENDING':
      return action.payload.options.isSearchingFromTopicBrowsePage ? setPending() : state;
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return action.payload.options.isSearchingFromTopicBrowsePage
        ? setFulfilled({ topicIds: action.payload.result.topics, searchText: action.payload.search })
        : state;
    case 'TYPEAHEAD.LOAD_REJECTED':
      return action.payload.options.isSearchingFromTopicBrowsePage ? setRejected(action.payload.error) : state;
    case 'TOPICS_SEARCH.QUERY_CLEARED':
      return initialState;
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.DELETE_TOPICS_FULFILLED':
      return removeFromTopicsSearch(state, action.payload.topicIds);
    case 'TOPIC.REMOVE_FULFILLED':
      return removeFromTopicsSearch(state, [action.payload.topicId]);
    default:
      return state;
  }
};

export default reducer;
